import React, { Fragment } from 'react';
import { Link } from 'react-router-dom';
import moment from 'moment';
import TankTypeText from '~/components/tankTypeText/tankTypeText';

const NextLotTransfer = ({ nextTransfer }) => {
  if (!nextTransfer) {
    return null;
  }

  const { type, transferDate, tank, tankType, vesselDescription, location } = nextTransfer;
  let transferText;
  switch (type) {
    case 'TANK':
      transferText = (
        <Fragment>
          to <TankTypeText type={tankType} />
          {tank ? (
            <Link to={`/tanks/${tank.id}`}>
              <em> {tank.name}</em>
            </Link>
          ) : null}
        </Fragment>
      );
      break;
    case 'VESSEL':
      transferText = (
        <Fragment>
          to vessels <em>{vesselDescription}</em>
        </Fragment>
      );
      break;
    case 'LOCATION':
      transferText = (
        <Fragment>
          to location <em>{location.name}</em>
        </Fragment>
      );
      break;
    case 'DRY_HOP':
      transferText = 'is dry hopping';
      break;
    case 'CLARIFICATION':
      transferText = 'is clarification';
      break;
    default:
      transferText = 'unknown';
      break;
  }

  return (
    <p>
      Next transfer step is {transferText} on {moment(transferDate).format('dddd Do MMMM')}
    </p>
  );
};

export default NextLotTransfer;



// WEBPACK FOOTER //
// ./src/components/nextLotTransfer/nextLotTransfer.jsx